(
    function (skyward, $, undefined)
    {
        skyward.yearend = skyward.yearend || {};

        var studentYearEndProcessSummaryID = "StudentYearEndProcessSummary";
        var processSummaryContainerTargetID = "ProcessSummaryContainerTarget";
        var processSummaryContainerTarget;
        var targetSchoolYearComboBoxID = "TargetSchoolYearID";

        var init = function (selector)
        {
            var studentYearEndProcessSummaryDiv = $("#" + studentYearEndProcessSummaryID);
            if (!studentYearEndProcessSummaryDiv.length)
            {
                return;
            }

            processSummaryContainerTarget = $("#" + processSummaryContainerTargetID);
            $("#" + targetSchoolYearComboBoxID).off("change", targetSchoolYearChanged).on("change", targetSchoolYearChanged);
        };

        var targetSchoolYearChanged = function ()
        {
            console.log("change fired");
            var selectedValue = skyward.controls.getValue($(this));
            console.log("selectedValue: " + selectedValue);

            $.ajax({
                url: skyward.global.virtualDir + "YearEnd/StudentYearEnd/TargetSchoolYearChange?renderType=contentOnly",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {
                    targetschoolyearid: skyward.controls.getValue($(this))
                },
                success: function (data)
                {
                    processSummaryContainerTarget.html(data);
                }
            });
        };

        skyward.yearend.yearEndMassRunUtilityCheckBoxClick = function (event)
        {
            CheckDependents($(event.target), false)
        };

        skyward.yearend.yearEndMassRunUtilityCheckBoxHover = function (event)
        {
            HoverDependents(event, $(event.target), false)
        };

        HoverDependents = function (event, parentElement)
        {
            var dependentsArray = parentElement.data("dependents").split(',');

            parentElement.closest("div").find(".checkbox:not([id^='ProcessesCheckboxGroup'][id$='_selectAll']):not(#" + parentElement.prop("id") + ")").each(function (index, element)
            {
                var otherDependentsArray = $(element).data("dependents").split(',');

                for (var i = 0; i < otherDependentsArray.length; i++)
                {
                    if (otherDependentsArray[i] != "" && otherDependentsArray[i] != null && $.inArray(otherDependentsArray[i], dependentsArray) != -1
                        && otherDependentsArray[i] != $(element).attr("id") && $(element).prop("checked"))
                    {
                        dependentsArray = $.grep(dependentsArray, function (value)
                        {
                            return value != otherDependentsArray[i];
                        });
                    }
                }
            });

            var selectAll = parentElement.closest("div").find("[id^='ProcessesCheckboxGroup'][id$='_selectAll']");
            for (var i = 0; i < dependentsArray.length; i++)
            {
                if (dependentsArray[i] != "" && dependentsArray[i] != null && dependentsArray[i] != parentElement.prop("id"))
                {
                    checkbox = $("#" + dependentsArray[i]);
                    var $overlay = $("<div class='massRunYearEndCheckboxOverlay'>")
                    $overlay.css({
                        height: checkbox.outerHeight(true),
                    })
                    if (!checkbox.parent().find('.massRunYearEndCheckboxOverlay').length)
                    {
                        checkbox.closest('td').css({position: "relative"})
                        checkbox.css({ position: "relative" })
                        checkbox.parent().prepend($("#YearEndDependencyIcon").clone()); // order matters for css rule, overlay must be before / prepended after 
                        checkbox.parent().prepend($overlay);
                    }
                    checkbox.parent().find('.massRunYearEndCheckboxOverlay').toggleClass("yearEndDependencyHovering", event.type === "mouseover" && checkbox.is(':not(:checked)'));
                    if (checkbox.closest('div').find("[id^='ProcessesCheckboxGroup'][id$='_selectAll']").get(0) === selectAll.get(0))
                    {
                        HoverDependents(event, checkbox);
                    }
                }
            }
        }

        CheckDependents = function (parentElement, uncheckDependents)
        {
            var dependentsArray = parentElement.data("dependents").split(',');

            parentElement.closest('div').find(".checkbox:not([id^='ProcessesCheckboxGroup'][id$='_selectAll']):not(#" + parentElement.prop("id") + ")").each(function (index, element)
            {
                var otherDependentsArray = $(element).data("dependents").split(',');

                for (var i = 0; i < otherDependentsArray.length; i++)
                {
                    //ignore black dependents, dependents not in the original dependent list, and self dependencies.
                    if (otherDependentsArray[i] != "" && otherDependentsArray[i] != null && $.inArray(otherDependentsArray[i], dependentsArray) != -1
                        && otherDependentsArray[i] != $(element).attr("id"))
                    {
                        if ($(element).prop("checked") /*&& !$(element).attr("disabled")*/)
                        {
                            dependentsArray = $.grep(dependentsArray, function (value)
                            {
                                return value != otherDependentsArray[i];
                            });
                        }
                    }
                }
            });

            var selectAll = parentElement.closest('div').find("[id^='ProcessesCheckboxGroup'][id$='_selectAll']");
            for (var i = 0; i < dependentsArray.length; i++)
            {
                if (dependentsArray[i] != "" && dependentsArray[i] != null && dependentsArray[i] != parentElement.prop("id"))
                {
                    if (parentElement.prop("checked"))
                    {
                        $("#" + dependentsArray[i]).attr("disabled", true);
                        $("#" + dependentsArray[i]).prop("checked", true);
                        $("#" + dependentsArray[i]).trigger("change");
                    }
                    else
                    {
                        $("#" + dependentsArray[i]).removeAttr("disabled");
                        if (uncheckDependents && $("#" + dependentsArray[i]).closest('div').find("[id^='ProcessesCheckboxGroup'][id$='_selectAll']").get(0) === selectAll.get(0))
                        {
                            $("#" + dependentsArray[i]).prop("checked", false);
                            CheckDependents($("#" + dependentsArray[i]), true);
                        }
                    }
                }
            }

            var uncheckedExist = false;
            var checkedExist = false;
            parentElement.closest('div').find(".checkbox:not([id^='ProcessesCheckboxGroup'][id$='_selectAll'])").each(function (index, element)
            {
                if (!$(element).prop("checked"))
                {
                    uncheckedExist = true;
                }
                else
                {
                    checkedExist = true;
                }
            });

            if (uncheckedExist && !checkedExist)
            {
                selectAll.prop("checked", false);
                selectAll.prop("indeterminate", false);
            }
            else if (!uncheckedExist && checkedExist)
            {
                selectAll.prop("checked", true);
                selectAll.prop("indeterminate", false);
            }

            if (uncheckedExist && checkedExist)
            {
                selectAll.prop("checked", true);
                selectAll.prop("indeterminate", true);
            }
        }

        skyward.yearend.yearEndmassRunSelectAll = function (event)
        {
            $(event.target).prop("indeterminate", false);
            var dependentsArray = $(event.target).data("dependents").dependents;
            var isChecked = $(event.target).prop("checked");
            for (var i = 0; i < dependentsArray.length; i++)
            {
                var dependentID = dependentsArray[i].Id;
                if (dependentID != "" && dependentID != null && !$("#" + dependentID).attr("disabled"))
                {
                    if (isChecked)
                    {
                        $("#" + dependentID).prop("checked", true);
                        $("#" + dependentID).trigger("change");
                    }
                    else                
                    {
                        $("#" + dependentID).prop("checked", false);
                        CheckDependents($("#" + dependentID), true);
                        $("#" + dependentID).removeAttr("disabled");
                    }
                }
            }
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
